// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"1785f938","84":"dfea6521","310":"ca2f8fa4","402":"2e48a164","656":"7198b497","796":"42192da4"}[chunkId] + ".chunk.css";
};